module.exports = __webpack_public_path__ + "img/05991564000157.11e8b682.png";